import { render, staticRenderFns } from "./activityList.vue?vue&type=template&id=2628e1b8&scoped=true"
import script from "./activityList.vue?vue&type=script&lang=js"
export * from "./activityList.vue?vue&type=script&lang=js"
import style0 from "./activityList.vue?vue&type=style&index=0&id=2628e1b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2628e1b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2628e1b8')) {
      api.createRecord('2628e1b8', component.options)
    } else {
      api.reload('2628e1b8', component.options)
    }
    module.hot.accept("./activityList.vue?vue&type=template&id=2628e1b8&scoped=true", function () {
      api.rerender('2628e1b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/tieTuNumber/activityList.vue"
export default component.exports